var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinancialVisibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    height: 64,
    viewBox: "0 0 16.933333 16.933334",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1-0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9175",
    d: "m6.879172 4.2363205v.0305c-1.7493627.6598857-2.9080849 2.3331576-2.91042 4.2028402.001043 1.8708203 1.1599944 3.5456613 2.91042 4.2059493v.0274c-3.70417 0-6.08542-4.2333393-6.08542-4.2333393s2.38125-4.2333302 6.08542-4.2333302z",
    fill: "#e4eff8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9177",
    d: "m10.054172 4.2363205v.0305c1.749359.6598889 2.908076 2.33316 2.91041 4.20284-.001 1.8708175-1.159988 3.5456585-2.91041 4.2059495v.0274c3.70416 0 6.08541-4.2333395 6.08541-4.2333395s-2.38125-4.2333302-6.08541-4.2333302z",
    fill: "#e4eff8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse9179",
    d: "m12.964571 8.4694672c0 2.4841308-2.013786 4.4979158-4.4979172 4.4979158-2.4841306 0-4.4979165-2.013785-4.4979167-4.4979158-.0000001-2.4841306 2.0137859-4.4979163 4.4979167-4.4979163 2.4841312-.0000003 4.4979172 2.0137855 4.4979172 4.4979163z",
    fill: "#ffca28",
    paintOrder: "stroke markers fill"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse9181",
    d: "m11.906237 8.4694672c0 1.8996288-1.539954 3.4395828-3.4395832 3.4395828-1.8996294 0-3.4395833-1.539954-3.4395833-3.4395828-.0000001-1.8996292 1.5399539-3.4395829 3.4395833-3.4395829 1.8996292.0000001 3.4395832 1.5399538 3.4395832 3.4395829z",
    fill: "#ffca28",
    paintOrder: "stroke markers fill"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9359",
    d: "m8.174872 6.3798305c-.56709 0-1.03125.4641799-1.03125 1.03125v.29101c0 .5670801.46417 1.03125 1.03125 1.03125h1.11133c.28308 0 .50195.2208501.50195.5039101v.2910094c0 .283081-.21887.501961-.50195.501961h-1.0586c-.28308 0-.50195-.21887-.50195-.501961.000097-.3529635-.529203-.3529635-.5293 0 0 .567081.46418 1.03125 1.03125 1.03125h1.0586c.56707 0 1.03125-.46416 1.03125-1.03125v-.2910094c0-.5670801-.46417-1.0332101-1.03125-1.0332101h-1.11133c-.28308 0-.50195-.21887-.50195-.50195v-.29101c0-.2830599.21888-.5019601.50195-.5019601h1.05859c.28308 0 .50196.2189002.50196.5019601-.0019.3547533.531189.3547533.52929 0 0-.5670701-.46416-1.03125-1.03125-1.03125z",
    fill: "#ecb200",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9365",
    d: "m8.728322 5.8192805c-.1469491.00158-.264461.122598-.26172.26953v4.7617195c-.000217.353083.529083.353083.5293 0v-4.7617195c.00278-.1492299-.1183338-.2712313-.26758-.26953z",
    fill: "#ecb200",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9371",
    d: "m7.910422 6.3798305c-.56709 0-1.03125.4641799-1.03125 1.03125v.29101c0 .5670801.46417 1.03125 1.03125 1.03125h1.11132c.28308 0 .50196.2208501.50196.5039101v.2910094c0 .283081-.21887.501961-.50196.501961h-1.05859c-.28308 0-.50195-.21887-.50195-.501961.000097-.3529635-.529203-.3529635-.5293 0 0 .567081.46417 1.03125 1.03125 1.03125h1.05859c.56708 0 1.03125-.46416 1.03125-1.03125v-.2910094c0-.5670801-.46416-1.0332101-1.03125-1.0332101h-1.11132c-.28309 0-.50196-.21887-.50196-.50195v-.29101c0-.2830599.21888-.5019601.50196-.5019601h1.05859c.28307 0 .50195.2189002.50195.5019601-.000097.3529635.529203.3529635.5293 0 0-.5670701-.46416-1.03125-1.03125-1.03125z",
    fill: "#e4eff8",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9374",
    d: "m8.463742 5.8192805c-.1469491.00158-.264461.122598-.26172.26953v4.7617195c-.00181.354666.531101.354666.52929 0v-4.7617195c.00278-.149226-.1183277-.2712256-.26757-.26953z",
    fill: "#e4eff8",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9396",
    d: "m8.466672 3.9717305c-.1044816-.0000049-.2089316.00363-.31316.0109 2.3952.1151574 4.278889 2.0890959 4.28191 4.4870603-.000083 2.3637372-1.829746 4.3241192-4.18786 4.4870592.072937.0054.1459956.009.21911.0109 2.484129-.000004 4.497912-2.01379 4.49791-4.4979194.000002-2.4841295-2.01378-4.4979165-4.49791-4.4979202z",
    fill: "#ecb200",
    paintOrder: "stroke markers fill"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#549ad4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9400",
    d: "m8.462892.79375001c-.1461754.001587-.2633695.12140527-.26172.26757999v.7949201c-.000097.3529635.529203.3529635.5293 0v-.7949201c.00168-.14846907-.1191109-.2692561-.26758-.26757999z",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9405",
    d: "m5.550782 1.8523501c-.2384906.00175-.3531278.2933225-.17969.45703l.5293.51562c.2526844.261144.6367878-.133115.36914-.3789l-.5293-.51563c-.050098-.050421-.1183737-.078568-.18945-.0781z",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9414",
    d: "m11.375002 1.8523501c-.06904.00108-.134928.02911-.18359.0781l-.52735.51563c-.267648.245785.116456.640044.36914.3789l.5293-.51562c.176318-.166317.05482-.462463-.1875-.45703z",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9593",
    d: "m8.462892 14.81236c-.1461754.0016-.2633695.121405-.26172.26758v.79492c-.000097.352964.529203.352964.5293 0v-.79492c.00168-.148469-.1191109-.269256-.26758-.26758z",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9679",
    d: "m6.083982 14.03306c-.068774.000576-.1346216.02791-.18359.0762l-.5293.51758c-.2674136.245791.1164484.639813.36914.37891l.5293-.51758c.1720261-.165884.053422-.456772-.18555-.45508z",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9738",
    d: "m10.841802 14.03306c-.235211.0052-.347148.291825-.17774.45508l.52735.51758c.252609.24768.623699-.13123.37109-.37891l-.5293-.51757c-.05089-.05021-.119926-.0777-.1914-.0762z",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path9740",
    d: "m2.11563.79375001c-.7376 0-1.32187999.59407999-1.32187999 1.32240009v2.65008c0 .3528701.52915999.3528701.52915999 0v-2.65008c0-.43088.34842-.7927201.79272-.7927201h2.64686c.14658-.0002599.26459-.11852.26459-.2651 0-.14657999-.11801-.26457999-.26459-.26457999z",
    fill: "#ff5151",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9762",
    d: "m12.170833.79375001c-.14658 0-.26459.118-.26459.26457999 0 .14658.11801.26432.26459.2645801l2.64687.0005212c.4443 0 .79272.36184.79272.79272v2.6500788c0 .3528701.52916.3528701.52916 0v-2.65008c0-.7283201-.58428-1.32240009-1.32188-1.32240009z",
    fill: "#ff5151",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9788",
    d: "m1.0583333 11.909983c-.14656996 0-.26457996.118-.26457996.26458v2.64313c0 .73762.59409996 1.32189 1.32239996 1.32189h2.91093c.35285 0 .35285-.52917 0-.52917h-2.91093c-.43087 0-.79272-.3484-.79272-.79272l-.000522-2.64313c-.000248-.14658-.117998-.26458-.264578-.26458z",
    fill: "#ff5151",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9790",
    d: "m15.875003 11.909983c-.14657 0-.26432.118-.26458.26458l-.000529 2.64313c.00001.44432-.36185.79272-.79272.79272h-2.646341c-.35285 0-.35285.52917 0 .52917h2.64635c.7283 0 1.3224-.58427 1.3224-1.32189v-2.64313c0-.14658-.118-.26458-.26458-.26458z",
    fill: "#ff5151",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "#000000",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "#000000",
    "solid-opacity": 1,
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9816",
    d: "m8.466672 5.0300705c-1.8996309-.0000036-3.4395884 1.5399493-3.43959 3.4395799-.0000038 1.8996346 1.5399553 3.4395936 3.43959 3.4395896.059468-.000458.1189152-.0025.17828-.006-1.7181049-.04672-3.0870933-1.45212-3.0887-3.1708592.0000002-1.7535038 1.4214959-3.1749996 3.175-3.175 1.692704.0007377 3.087178 1.3292851 3.16983 3.0199701.0022-.035802.0039-.071636.005-.1074902-.000002-1.8996267-1.539953-3.439578-3.43958-3.4395799z",
    fill: "#ecb200",
    paintOrder: "stroke markers fill"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9885",
    d: "m11.716082 5.3732004c.798009.8337519 1.244999 1.9423495 1.2485 3.09645-.001 1.8708176-1.159988 3.5456586-2.91041 4.2059496v.0274c.3268 0 .64278-.0345.94826-.0946 1.377233-.80567 2.224558-2.280671 2.22674-3.8762496-.0017-1.28433-.552299-2.5066862-1.51309-3.3589698z",
    fill: "#c4dcf0",
    paintOrder: "stroke markers fill"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialVisibility);
export default __webpack_public_path__ + "static/media/financial-visibility.97e56753242708f11e1ab05a6e331365.svg";
export { ForwardRef as ReactComponent };